<template>
	<div class="col-12">
		<b-overlay :show="loading" class="content">
			<div class="mb-3 text-center">
				<hr />
				<strong>ارسال درخواست</strong>
				<hr />
			</div>

			<div class="alert alert-info">
				<span>دارنده گرامی نیکارت!<br /> جهت تغییر رمز اول و یا دریافت رمز دوم کارت خود به یکی از نمایندگی های نیکارت و یا معاونت تعاون سازمان خود مراجعه فرماید. </span>
			</div>

			<div class="col-12 p-0 float-left">
				<div class="row">
					<div v-for="(item, index) in requests"
						 class="col-12 col-md-6 col-lg-3 float-dynamic" @click="showRequestModal(item,index)" v-if="item.visible">
						<b-overlay :show="item.loading" class="dashboard-card request bg-white text-dark">
							<strong class="d-block money number mb-3">
								<font-awesome-icon class="mr-2 ml-2" :style="{color:item.iconColor }" size="2x" :icon="item.icon" />
							</strong>
							<span class="font-weight-bold d-block mb-3">{{ item.name }}</span>
						</b-overlay>
					</div>
				</div>
			</div>

			<div class="col-12 p-0 float-left">
				<div class="col-12 float-dynamic">
					<div class="col-12 p-0 col-md-4">
						<strong class="d-block mb-1 mt-4">درخواست های شما</strong>
						<hr />
					</div>
				</div>
				<CustomerRequest :key="requestKey" />
			</div>

			<b-modal size="lg" hide-footer id="defaultRequestModal">
				<div class="text-center" v-if="loadingOrganizationInfo || loadingOrganizations">
					<span>لطفا کمی صبر کنید ...</span>
				</div>
				<div v-else>

					<div v-if="isShowSelectOrganization == false">
						<div v-if="organizationInfo">
							<div class="text-center">
								کاربر گرامی! سازمان فعلی شما در سیستم نیکارت '<strong>{{organizationInfo.organizationName}}</strong>' ثبت شده است. لطفا در صورت مغایرت ابتدا اطلاعات سازمانی خود را ویرایش نمایید.
							</div>
							<div class="col-12 col-md-8 offset-md-2 float-left text-center mt-5">
								<b-button class="m-1 w-100 btn-warning" @click="handleEditOrganization">ویرایش اطلاعات سازمان</b-button>
								<b-button class="m-1 w-100 btn-success" @click="confirmRequestModal()">اطلاعات سازمانی من صحیح است. {{ selectedRequest.name }}</b-button>
							</div>
						</div>
						<div v-else>
							<div>
								کاربر گرامی! اطلاعات سازمانی شما در نیکارت ثبت نشده است، لطفا قبل از اقدام به ارسال درخواست اطلاعات سازمانی خود را ویرایش نمایید..
							</div>
							<div class="col-12 col-md-8 offset-md-2 float-left text-center mt-5">
								<b-button class="m-1 w-100 btn-warning" @click="handleEditOrganization">ویرایش اطلاعات سازمان</b-button>
							</div>
						</div>
					</div>

					<div v-else>
						<div class="row" v-if="selectedProvince == null">
							<div class="col-12 text-center mb-3">
								لطفا استان سازمان خود را انتخاب نمایید
							</div>
							<div class="col-6 col-md-3" v-for="(province,index) in organizationProvinces" :key="index">
								<b-button class="w-100 mb-3" variant="outline-dark" @click="handleSelectProvince(province)">
									{{province.name}}
								</b-button>
							</div>
						</div>

						<div class="row" v-else>
							<div class="col-12 text-center mb-3">
								لطفا سازمان خود را انتخاب نمایید
							</div>
							<div class="col-12 mb-3">
								<b-button class="mb-3 float-right" @click="selectedProvince = null">
									بازگشت
								</b-button>
							</div>
							<div class="col-12 text-center mb-3">
								<input type="text" v-model="organizationFilter" class="form-control" placeholder="جستجو کنید ..." />
							</div>
							<div class="col-12 col-md-6" v-for="(organization,index) in organizations" :key="index" v-if="checkFilterOrganization(organization)">
								<b-button class="w-100 mb-3" variant="outline-dark" @click="handleSelectOrganization(organization)">
									{{organization.name}}
								</b-button>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12 col-md-8 offset-md-2 float-left text-center">
					<b-button class="m-1 w-100 btn-dark" @click="$bvModal.hide('defaultRequestModal')">انصراف</b-button>
				</div>
			</b-modal>

		</b-overlay>
	</div>
</template>
<script>
	import CustomerRequest from "@/views/club/CustomerRequest";
	import { timers } from "jquery";
	export default {

		components: {
			CustomerRequest
		},

		data()
		{
			return {
				requestKey: 0,
				screenWidth: null,
				loading: false,

				organizationInfo: null,
				selectedProvince: null,
				organizations: [],
				organizationProvinces: [],
				organizationFilter: '',

				loadingOrganizationInfo: false,
				loadingOrganizationProvinces: false,
				loadingOrganizations: false,
				isShowSelectOrganization: false,

				selectedRequest: {},
				selectedRequestIndex: null,
				customerRequests: [],
				requests: [
					{
						requestTypeId: 1,
						key: "getCard",
						name: "ارسال درخواست صدور نیکارت",
						icon: "credit-card",
						iconColor: "#444",
						loading: false,
						visible: true,
					},

					{
						requestTypeId: 6,
						key: "chargeCard",
						name: "ارسال درخواست شارژ نیکارت",
						icon: "battery-full",
						iconColor: "#444",
						loading: false,
						visible: true,
					},

					{
						requestTypeId: 7,
						key: "lostCard",
						name: "ارسال اعلام مفقودی نیکارت",
						icon: "credit-card",
						iconColor: "#444",
						loading: false,
						visible: true,
					},

					{
						requestTypeId: 68,
						key: "editOrganization",
						name: "ارسال درخواست تغییر سازمان",
						icon: "credit-card",
						iconColor: "#444",
						loading: false,
						visible: false,
					},
				]
			};
		},

		beforeMount()
		{
			this.screenWidth = window.outerWidth;
			this.initOrganizationInfo();
		},

		methods: {
			initTable()
			{
				this.loading = true;

				const data = {
					Search: "",
					Start: (this.currentPage - 1) * this.perPage,
					Length: 10
				};
			},

			handleEditOrganization()
			{
				this.isShowSelectOrganization = true;
				this.initOrganizationProvinces();
			},

			initOrganizationInfo()
			{
				axios({
					method: 'GET',
					url: '/api/app/GetCustomerOrganization'
				})
					.then(r =>
					{
						if (r && r.data.success)
						{
							this.organizationInfo = r.data.meta.organization
						}
					})
					.catch(error =>
					{
						this.errors = [{ type: 'errors.server' }];
						this.loading = false;
					});
			},

			initOrganizationProvinces()
			{
				this.loadingOrganizations = true;
				axios({
					method: 'GET',
					url: '/api/organization/GetOrganizationProvinces'
				})
					.then(r =>
					{
						if (r && r.data.success)
						{
							this.organizationProvinces = r.data.meta.items
						}
						this.loadingOrganizations = false;
					})
					.catch(error =>
					{
						this.loadingOrganizations = false;
						this.showServerError()
					});
			},


			handleSelectProvince(province)
			{
				this.selectedProvince = province
				this.loadingOrganizations = true;

				axios({
					method: 'GET',
					url: `/api/organization/GetOrganizationByProvinceId?provinceId=${province.provinceId}`,
				})
					.then(r =>
					{
						if (r && r.data.success)
						{
							this.organizations = r.data.meta.items
						}

						this.loadingOrganizations = false;
					})
					.catch(error =>
					{
						this.loadingOrganizations = false;
						this.showServerError()
					});
			},

			checkFilterOrganization(item)
			{
				if (this.organizationFilter == '')
				{
					return true;
				}

				return item.name.includes(this.organizationFilter)
			},


			handleSelectOrganization(organization)
			{
				this.$bvModal.msgBoxConfirm(`آیا نسبت به انتخاب '${organization.name}' اطمینان دارید؟`, {
					title: 'ویرایش اطلاعات سازمان',
					size: 'lg',
					buttonSize: 'sm',
					okVariant: 'success',
					contentClass:'text-center',
					okTitle: 'بله',
					cancelTitle: 'خیر',
					footerClass: 'p-2',
					hideHeaderClose: true,
					centered: true
				})
					.then(value =>
					{
						if (value)
						{
							if (this.organizationInfo)
							{
								if (this.organizationInfo.organizationName == organization.name)
								{
									this.loadingOrganizations = false;
									this.isShowSelectOrganization = false;
									this.selectedProvince = null
									this.$bvModal.hide('defaultRequestModal');
									this.sendRequest()

									return
								}
							}


							this.loadingOrganizations = false;
							this.isShowSelectOrganization = false;
							this.selectedProvince = null
							this.selectedRequestIndex = 3;
							this.selectedRequest = this.requests[3]
							this.$bvModal.hide('defaultRequestModal');
							this.sendRequest(`سازمان جدید : ${organization.name}`)
						}
					})
					.catch(err =>
					{
					})
			},


			showRequestModal(request, index)
			{
				this.loadingOrganizations = false;
				this.isShowSelectOrganization = false;
				this.selectedProvince = null

				this.selectedRequest = request;
				this.selectedRequestIndex = index;

				this.$bvModal.show('defaultRequestModal');
			},

			confirmRequestModal()
			{
				this.$bvModal.hide('defaultRequestModal');

				switch (this.selectedRequest.key)
				{
					case "resetPin1":
						this.sendRequestResetPin1();
						break;

					case "resetPin2":
						this.sendRequestResetPin2();
						break;

					default:
						this.sendRequest();
						break;
				}
			},

			sendRequest(comment)
			{
				this.requests[this.selectedRequestIndex].loading = true

				var payload = {
					RequestTypeID: this.selectedRequest.requestTypeId,
					NewPassword: this.newPassword
				}

				if (comment)
				{
					payload.comment = comment
				}

				axios({ method: "post", url: "/api/App/SaveRequest", data: payload })
					.then(response =>
					{
						this.requests[this.selectedRequestIndex].loading = false

						if (response.data.success)
						{
							this.$bvToast.toast('درخواست شما با شماره ' + response.data.meta.requestId + ' با موفقیت ثبت شد', {
								title: 'عملیات موفق',
								toaster: 'b-toaster-top-center',
								variant: 'success',
								bodyClass: 'text-center',
								noCloseButton: true,
								solid: true
							})

							this.requestKey += 1;

							return;
						}
						else if ((response.data.meta || {}).customError)
						{
							this.$bvToast.toast(response.data.meta.customError, {
								title: 'عملیات ناموفق',
								toaster: 'b-toaster-top-center',
								variant: 'danger',
								bodyClass: 'text-center',
								noCloseButton: true,
								solid: true
							})

							return;
						}
						else
						{
							if (response.data.meta.message == "Request Duplicate")
							{
								this.$bvToast.toast('این درخواست قبلا با شماره ' + response.data.meta.requestId + ' برای شما ثبت شده و همچنان در دست اقدام است', {
									title: 'درخواست تکراری',
									toaster: 'b-toaster-top-center',
									variant: 'warning',
									bodyClass: 'text-center',
									noCloseButton: true,
									solid: true
								})

								return;
							}

							if (response.data.meta.message == "Request Rejected")
							{
								this.$bvToast.toast('درخواست پذیرفته نشد! از درخواست قبلی شما باید یک ماه گذشته باشد تا بتوانید درخواست جدید ارسال نمایید.', {
									title: 'درخواست تکراری',
									toaster: 'b-toaster-top-center',
									variant: 'warning',
									bodyClass: 'text-center',
									noCloseButton: true,
									solid: true
								})

								return;
							}
						}

						this.$bvToast.toast('خطا در ثبت درخواست، لطفا با پشتیانی سیستم تماس بگیرید.', {
							title: 'عملیات ناموفق',
							toaster: 'b-toaster-top-center',
							variant: 'danger',
							bodyClass: 'text-center',
							noCloseButton: true,
							solid: true
						})
					})
					.catch(error =>
					{
						this.requests[this.selectedRequestIndex].loading = false
						this.$bvToast.toast('خطا در ثبت درخواست، لطفا با پشتیانی سیستم تماس بگیرید.', {
							title: 'عملیات ناموفق',
							toaster: 'b-toaster-top-center',
							variant: 'danger',
							bodyClass: 'text-center',
							noCloseButton: true,
							solid: true
						})
					});
			},



			sendRequestEditOrganization()
			{
				this.requests[this.selectedRequestIndex].loading = true

				axios({ method: "post", url: "/api/App/ResetPin1", data: null })
					.then(response =>
					{
						this.requests[this.selectedRequestIndex].loading = false

						if (response.data.success)
						{
							this.$bvToast.toast('رمز جدید با موفقیت برای شما ارسال شد', {
								title: 'عملیات موفق',
								toaster: 'b-toaster-top-center',
								variant: 'success',
								bodyClass: 'text-center',
								noCloseButton: true,
								solid: true
							})

							this.requestKey += 1;

							return;
						}


						this.$bvToast.toast('خطا در ارسال رمز، لطفا با پشتیبانی سیستم تماس حاصل فرمایید.', {
							title: 'عملیات ناموفق',
							toaster: 'b-toaster-top-center',
							variant: 'danger',
							bodyClass: 'text-center',
							noCloseButton: true,
							solid: true
						})
					})
					.catch(error =>
					{
						this.requests[this.selectedRequestIndex].loading = false
						this.$bvToast.toast('خطا در ارسال رمز، لطفا با پشتیبانی سیستم تماس حاصل فرمایید.', {
							title: 'عملیات ناموفق',
							toaster: 'b-toaster-top-center',
							variant: 'danger',
							bodyClass: 'text-center',
							noCloseButton: true,
							solid: true
						})
					});
			},


			sendRequestResetPin1()
			{
				this.requests[this.selectedRequestIndex].loading = true

				axios({ method: "post", url: "/api/App/ResetPin1", data: null })
					.then(response =>
					{
						this.requests[this.selectedRequestIndex].loading = false

						if (response.data.success)
						{
							this.$bvToast.toast('رمز جدید با موفقیت برای شما ارسال شد', {
								title: 'عملیات موفق',
								toaster: 'b-toaster-top-center',
								variant: 'success',
								bodyClass: 'text-center',
								noCloseButton: true,
								solid: true
							})

							this.requestKey += 1;

							return;
						}


						this.$bvToast.toast('خطا در ارسال رمز، لطفا با پشتیبانی سیستم تماس حاصل فرمایید.', {
							title: 'عملیات ناموفق',
							toaster: 'b-toaster-top-center',
							variant: 'danger',
							bodyClass: 'text-center',
							noCloseButton: true,
							solid: true
						})
					})
					.catch(error =>
					{
						this.requests[this.selectedRequestIndex].loading = false
						this.$bvToast.toast('خطا در ارسال رمز، لطفا با پشتیبانی سیستم تماس حاصل فرمایید.', {
							title: 'عملیات ناموفق',
							toaster: 'b-toaster-top-center',
							variant: 'danger',
							bodyClass: 'text-center',
							noCloseButton: true,
							solid: true
						})
					});
			},

			showServerError()
			{
				this.$bvToast.toast('خطا در برقراری ارتباط با سرور.', {
					title: 'عملیات ناموفق',
					toaster: 'b-toaster-top-center',
					variant: 'danger',
					bodyClass: 'text-center',
					noCloseButton: true,
					solid: true
				})
			},


			sendRequestResetPin2()
			{
				this.requests[this.selectedRequestIndex].loading = true

				axios({ method: "post", url: "/api/App/ResetPin2", data: null })
					.then(response =>
					{
						this.requests[this.selectedRequestIndex].loading = false

						if (response.data.success)
						{
							this.$bvToast.toast('رمز جدید با موفقیت برای شما ارسال شد', {
								title: 'عملیات موفق',
								toaster: 'b-toaster-top-center',
								variant: 'success',
								bodyClass: 'text-center',
								noCloseButton: true,
								solid: true
							})

							this.requestKey += 1;

							return;
						}


						this.$bvToast.toast('خطا در ارسال رمز، لطفا با پشتیبانی سیستم تماس حاصل فرمایید.', {
							title: 'عملیات ناموفق',
							toaster: 'b-toaster-top-center',
							variant: 'danger',
							bodyClass: 'text-center',
							noCloseButton: true,
							solid: true
						})
					})
					.catch(error =>
					{
						this.requests[this.selectedRequestIndex].loading = false
						this.$bvToast.toast('خطا در ارسال رمز، لطفا با پشتیبانی سیستم تماس حاصل فرمایید.', {
							title: 'عملیات ناموفق',
							toaster: 'b-toaster-top-center',
							variant: 'danger',
							bodyClass: 'text-center',
							noCloseButton: true,
							solid: true
						})
					});
			}

		}
	};
</script>
<style>

	.rtl {
		direction: rtl;
	}

	.request {
		height: 180px;
		padding-top: 50px;
		cursor: pointer;
		transition: all .1s;
	}

		.request:hover {
			transform: scale(1.05)
		}
</style>
